import React, { useState } from 'react'
import { Modal, Form, Input, Button, notification } from 'antd';

import './index.less'

export default function ServiceModal(props) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const onFinish = async (formData) => {
    try {
      const { username, phone, companyName, content } = formData;
      // const text = `姓名【${username}】，手机号【${phone}】，公司名称【${companyName}】，咨询来源【官网首页】。`; \r\n企业/服务机构：“${props.portalType}”
      const text = `咨询来源：数秦官网\r\n姓名：${username}\r\n手机号码：${phone}\r\n公司名称：${companyName}\r\n咨询意向：${content || ''}`;
      setLoading(true)
        await fetch('/prod-api/system/fs/message', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text }),
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((res) => { setOpen(false)});
      setOpen(false)
      notification.success({
        message: "温馨提示",
        description: "发送成功，请耐心等待",
      });
    } catch (err) {
      console.log(err);
      err.message &&
      notification.error({
        message: "错误",
        description: err.message,
      });
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={props.style}>
      <div onClick={() => setOpen(true)}>
        {props.children}
      </div>

      <Modal 
        width={604} 
        open={open} 
        footer={null} 
        onCancel={() => setOpen(false)}
        className="service-modal" 
        destroyOnClose>

        <div className="service-modal-title">
          服务咨询
        </div>
        <div className="service-modal-desc">
          您可以留下联系方式，我们的服务顾问将尽快与您联系
        </div>

        <Form
          className='service-modal-form'
          layout='vertical'
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}>
          <Form.Item 
            label="姓名" 
            name="username"
            validateTrigger={['onBlur', 'onChange']}
            rules={[{ required: true, message: "请输入您的姓名" }]}>
            <Input size='large' placeholder='请输入您的姓名' bordered={false} />
          </Form.Item>
          <Form.Item 
            label="手机号码" 
            name="phone" 
            validateTrigger={['onBlur', 'onChange']}
            rules={[
              { required: true, message: "请输入您的手机号" },
              { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码", validateTrigger: 'onBlur' }
            ]}>
            <Input size='large' placeholder='请输入您的手机号码' bordered={false} />
          </Form.Item>
          <Form.Item 
            label="公司名称" 
            name="companyName"
            validateTrigger={['onBlur', 'onChange']}
            rules={[
              { required: true, message: "请输入您的公司名称" }
            ]}>
            <Input size='large' placeholder='请输入您的公司名称' bordered={false} />
          </Form.Item>
          <Form.Item 
            label="咨询意向" 
            name="content">
            <Input.TextArea size='large' placeholder='请输入您的咨询意向' bordered={false} maxLength={200} showCount />
          </Form.Item>

          <Button className='service-modal-button' type="primary" htmlType="submit" block size='large' loading={loading}>
            提交
          </Button>
        </Form>
      </Modal>
    </div>
  )
}
